export default function () {
    const $config = useRuntimeConfig().public;

    function buildReactiveHead(event, error) {
        watch(
            event,
            () => {
                buildHead(event.value, error.value);
            },
            {immediate: true},
        );
    }

    function buildHead(event, error) {
        if (event === null && !error) return useSeo().buildHeadLoading();
        if (!event) return useSeo().buildHeadNotFound();
        return useSeo().buildHead({
            title: event.event_title + ' | West Coast Swing Event',
            description: stripTags(event.event_description) || 'View the videos from this event.',
            image: event.event_jumbo ? $config.images + event.event_jumbo : null,
            index: true,
        });
    }

    function stripTags(html) {
        return html.replace(/(<([^>]+)>)/gi, ' ');
    }

    return {buildReactiveHead};
}
